import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { handleShowModal } from 'components/global/_helpers/global.helpers';
import PageTitle from 'components/global/PageTitle/PageTitle';
import FounderCreatePipelineModal from 'components/views/FounderPipeline/_components/FounderCreatePipelineModal';
import FounderPipeline from 'components/views/FounderPipeline/_components/FounderPipeline';
import { Button } from 'react-bootstrap';
import { useEffectAsync } from 'utils/useEffectAsync';
import { fetchAndSetInvestorOptionsData } from 'components/views/FounderPipeline/_helpers/founderPipeline.resolvers';
import withDismount from 'hocs/withDismount';

const FounderInvestorsList = () => {
  useEffectAsync(fetchAndSetInvestorOptionsData, []);
  return (
    <>
      <PageTitle Buttons={(
        <Button className="me-16 text-info border-dark bg-dark" variant="transparent" size="sm" onClick={() => handleShowModal('founder-pipeline-create')}>
          <FontAwesomeIcon icon={faPlus} className="me-8" size="sm" />
          Add to Pipeline
        </Button>
      )}
      >
        Pipeline
      </PageTitle>
      <FounderPipeline />
      <FounderCreatePipelineModal />
    </>
  );
};

export default withDismount(FounderInvestorsList);
